import type { AnalysisDaySchema } from '@libs/data-access/entities'
import { Flex } from '@libs/ui/ds'
import { usePlanningAnalysisTranslation } from '@libs/utils/translations'
import React from 'react'
import type { FC } from 'react'

import DailyStatisticsColumn from '../DailyStatisticsColumn/DailyStatisticsColumn'

type Props = {
  real: boolean
  canSeeWagesRatio: boolean
  dailyStatistics: AnalysisDaySchema[]
  teamId?: number
  locationId?: number
}
const DailyStatistics: FC<Props> = ({
  real,
  canSeeWagesRatio,
  dailyStatistics,
  teamId,
  locationId
}) => {
  const { t } = usePlanningAnalysisTranslation()

  return (
    <Flex row className='w-full flex-nowrap'>
      <Flex className='max-w-64 flex-1 justify-between border-r-1 border-r-neutral-200 pb-2.5 pt-6'>
        <div className='ml-4 pb-4'>
          {real ? t('dailyStatistics.realSales') : t('dailyStatistics.sales')}
        </div>
        <div className='ml-4 pb-4'>
          {real
            ? t('dailyStatistics.realHours')
            : t('dailyStatistics.plannedHours')}
        </div>
        <div className='ml-4 pb-4'>
          {real
            ? t('dailyStatistics.realProductivity')
            : t('dailyStatistics.productivity')}
        </div>
        {canSeeWagesRatio && (
          <div>
            <div className='ml-4 pb-4'>
              {real
                ? t('dailyStatistics.realPayroll')
                : t('dailyStatistics.payroll')}
            </div>
            <div className='ml-4 pb-4'>
              {real
                ? t('dailyStatistics.realPayrollRatio')
                : t('dailyStatistics.payrollRatio')}
            </div>
          </div>
        )}
      </Flex>
      {dailyStatistics && (
        /* TODO: Ask the design/product to create a fallback for error state/empty state */
        <Flex row className='flex-1 flex-nowrap'>
          {dailyStatistics.map(data => (
            <DailyStatisticsColumn
              key={`daily-statistic-${data.date}-${teamId}-${locationId}`}
              real={real}
              data={data}
              canSeeWagesRatio={canSeeWagesRatio}
            />
          ))}
        </Flex>
      )}
    </Flex>
  )
}

export default DailyStatistics
